export const DEFAULT_LOGGED_IN_ROUTE = '/select-practice'
export const IS_ACH_DISABLED = true
